import {
  ALLOWED_SETTINGS_KEYS,
  SettingValue,
  setSetting,
  getSetting,
  LanguageOption,
  allLanguages,
  Language,
} from "./setttings";
import {
  updateApiUrl,
  defaultApiUrl,
  getCaseLlmReferences,
  postDocumentLlmReference,
  deleteDocumentLlmReference,
  documentFile,
} from "./rest_utils";
import {
  getHtmlBodyContentFile,
  textToContentFile,
  getSelectedText,
  getSelectedTextHtml,
  getContentFile,
  documentNamePrefix,
} from "./word_utils";
import { createCaseWithFiles } from "./llm_utils";
import { toastMessage } from "./common";
import { TaskCategory } from "./task_utils";
import { translate } from "../locales/i18n";

const urlPattern = new RegExp(
  "^https?:\\/\\/" + // protocol (required)
    "((([a-z\\d]([a-z\\d-]*[a-z\\d])?)\\.)+[a-z]{2,}|" + // domain
    "localhost|" + // localhost
    "\\d{1,3}(\\.\\d{1,3}){3}|" + // IPv4
    "\\[([a-fA-F0-9:]+)\\])" + // IPv6 in []
    "(\\:\\d{1,5})?" + // optional port
    "(\\/[-a-z\\d%_.~+]*)*" + // path
    "(\\?[;&a-z\\d%_.~+=-]*)?" + // query
    "(\\#[-a-z\\d_]*)?$",
  "i"
);

export class SettingsElement {
  private settingsElement: HTMLDivElement;
  private settingsButton: HTMLButtonElement;
  private settingsModal: CustomModal;

  constructor(isLogin: boolean = false) {
    this.settingsElement = document.createElement("div");
    this.settingsButton = document.createElement("button");

    this.settingsElement.classList.add("settings-element");
    this.settingsButton.classList.add("settings-button"); // same as nav-button
    this.settingsElement.title = translate("settings");
    // this.settingsButton.innerHTML =
    //   '<span role="img" aria-label="setting" class="anticon anticon-setting icon"><svg focusable="false" class="" data-icon="setting" width="1em" height="1em" fill="currentColor" aria-hidden="true" viewBox="64 64 896 896"><path d="M924.8 625.7l-65.5-56c3.1-19 4.7-38.4 4.7-57.8s-1.6-38.8-4.7-57.8l65.5-56a32.03 32.03 0 009.3-35.2l-.9-2.6a443.74 443.74 0 00-79.7-137.9l-1.8-2.1a32.12 32.12 0 00-35.1-9.5l-81.3 28.9c-30-24.6-63.5-44-99.7-57.6l-15.7-85a32.05 32.05 0 00-25.8-25.7l-2.7-.5c-52.1-9.4-106.9-9.4-159 0l-2.7.5a32.05 32.05 0 00-25.8 25.7l-15.8 85.4a351.86 351.86 0 00-99 57.4l-81.9-29.1a32 32 0 00-35.1 9.5l-1.8 2.1a446.02 446.02 0 00-79.7 137.9l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.3 56.6c-3.1 18.8-4.6 38-4.6 57.1 0 19.2 1.5 38.4 4.6 57.1L99 625.5a32.03 32.03 0 00-9.3 35.2l.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1a32.12 32.12 0 0035.1 9.5l81.9-29.1c29.8 24.5 63.1 43.9 99 57.4l15.8 85.4a32.05 32.05 0 0025.8 25.7l2.7.5a449.4 449.4 0 00159 0l2.7-.5a32.05 32.05 0 0025.8-25.7l15.7-85a350 350 0 0099.7-57.6l81.3 28.9a32 32 0 0035.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l.9-2.6c4.5-12.3.8-26.3-9.3-35zM788.3 465.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9a370.03 370.03 0 01-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97a377.5 377.5 0 01-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426l6.5 39.9zM512 326c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 01512 614c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 01400 502c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390c29.9 0 58 11.6 79.2 32.8A111.6 111.6 0 01624 502c0 29.9-11.7 58-32.8 79.2z"></path></svg></span>';
    this.settingsButton.innerHTML = '<i class="fa fa-cog"></i>';

    this.settingsElement.appendChild(this.settingsButton);

    // ... already there for smooth blend in transition
    this.settingsModal = new CustomModal();
    if (isLogin) {
      this.settingsModal.addField("apiUrl", translate("server-url"));
    }
    this.settingsModal.addField("language", translate("language"));

    this.settingsButton.onclick = async () => {
      let apiUrlChanged = false;
      let languageChanged = false;
      this.settingsModal.open(
        async (values: Partial<Record<ALLOWED_SETTINGS_KEYS, SettingValue>>) => {
          for (const [key, value] of Object.entries(values)) {
            if (value) {
              await setSetting(key as ALLOWED_SETTINGS_KEYS, value);
              if (key === "apiUrl") apiUrlChanged = true;
              if (key === "language") languageChanged = true;
            }
          }
          if (apiUrlChanged) await updateApiUrl();
          if (languageChanged) location.reload();
        }
      );
    };
  }

  public elem(): HTMLDivElement {
    return this.settingsElement;
  }
}

export class CustomModal {
  private overlay: HTMLElement;
  private modalContainer: HTMLElement;
  private form: HTMLFormElement;
  private okButton: HTMLButtonElement;
  private fields: Map<ALLOWED_SETTINGS_KEYS, HTMLInputElement | HTMLSelectElement>;
  private openValues: Partial<Record<ALLOWED_SETTINGS_KEYS, SettingValue>> = {};
  private confirmCallback:
    | ((values: Partial<Record<ALLOWED_SETTINGS_KEYS, SettingValue>>) => Promise<void>)
    | null = null;
  private languageSelect: HTMLSelectElement | null = null;

  constructor() {
    this.fields = new Map();

    this.overlay = document.createElement("div");
    this.overlay.classList.add("custom-modal-overlay");

    this.modalContainer = document.createElement("div");
    this.modalContainer.classList.add("custom-modal-container");

    this.form = document.createElement("form");
    this.form.classList.add("custom-modal-form", "flex", "flex-col");

    const buttonContainer = document.createElement("div");
    buttonContainer.classList.add("custom-modal-buttons");

    this.okButton = document.createElement("button");
    this.okButton.type = "submit";
    this.okButton.textContent = translate("save");
    this.okButton.classList.add("btn", "btn-primary");
    this.okButton.addEventListener("click", (event) => {
      event.preventDefault();
      this.submitForm();
    });
    this.okButton.disabled = true;

    const cancelButton = document.createElement("button");
    cancelButton.type = "button";
    cancelButton.textContent = translate("cancel");
    cancelButton.classList.add("btn", "btn-menu");
    cancelButton.addEventListener("click", () => this.close());

    buttonContainer.appendChild(this.okButton);
    buttonContainer.appendChild(cancelButton);

    this.modalContainer.appendChild(this.form);
    this.modalContainer.appendChild(buttonContainer);
    this.overlay.appendChild(this.modalContainer);
    document.body.appendChild(this.overlay);

    // maybe add "close on backround click" if wanted
    // this.overlay.addEventListener("click", (event) => {
    //   if (event.target === this.overlay) {
    //     this.close();
    //   }
    // });
  }

  private submitForm(): void {
    if (this.confirmCallback) {
      const result: Partial<Record<ALLOWED_SETTINGS_KEYS, SettingValue>> = {};
      this.fields.forEach((input, key) => {
        result[key] = input.value.trim();
      });
      this.confirmCallback(result);
    } else {
      console.warn("No confirm callback function set! Results discarded.");
    }
    this.close();
  }

  public async open(
    onConfirm: (values: Partial<Record<ALLOWED_SETTINGS_KEYS, SettingValue>>) => Promise<void>
  ) {
    this.confirmCallback = onConfirm;
    this.overlay.classList.add("visible");

    if (this.languageSelect) {
      const storedLanguage = await getSetting("language");
      this.languageSelect.selectedIndex =
        Array.from(this.languageSelect.options).findIndex(
          (option) => option.value === storedLanguage
        ) ?? 0;
    }

    this.fields.forEach((input, key) => {
      this.openValues[key] = input.value;
    });
  }

  public close() {
    this.overlay.classList.remove("visible");
    setTimeout(() => {
      this.clearFields();
    }, 500);
  }

  public addField(name: ALLOWED_SETTINGS_KEYS, labelText?: string): void {
    const modalItem = document.createElement("div");
    modalItem.classList.add("custom-modal-item", "flex", "flex-col");
    const modalItemFieldMain = document.createElement("div");
    modalItemFieldMain.classList.add("custom-modal-item-field", "flex", "flex-row");

    const label = document.createElement("label");
    label.textContent = labelText ?? name;
    label.setAttribute("for", `field-${name}`);

    let input: HTMLInputElement | HTMLSelectElement;

    if (name === "apiUrl") {
      input = document.createElement("input");
      input.type = "text";
      input.id = `field-${name}`;
      input.name = name;
      input.classList.add("custom-modal-input");

      input.placeholder = "https://api.example.com";
      input.addEventListener("input", () => {
        if (input.value === "") {
          input.classList.remove("invalid");
          return;
        }
        if (urlPattern.test(input.value)) {
          input.classList.remove("invalid");
        } else {
          input.classList.add("invalid");
        }
      });

      const resetLink = document.createElement("a");
      resetLink.href = "#";
      resetLink.textContent = translate("reset");
      resetLink.classList.add("reset-link");
      resetLink.onclick = async (event) => {
        event.preventDefault();
        input.value = defaultApiUrl;
        input.dispatchEvent(new Event("input"));
      };

      const modalItemFieldSecond = document.createElement("div");
      modalItemFieldSecond.classList.add("custom-modal-item-field", "flex", "flex-row");
      modalItemFieldSecond.appendChild(resetLink);
      modalItem.appendChild(modalItemFieldSecond);
    } else if (name === "language") {
      input = document.createElement("select");
      input.id = `field-${name}`;
      input.name = name;
      input.classList.add("custom-modal-input");

      allLanguages.forEach((lang: Language) => {
        const option = document.createElement("option");
        option.value = lang.value;
        option.textContent = lang.label;
        input.appendChild(option);
      });

      this.languageSelect = input;
    } else {
      return; // uugh ts
    }

    modalItemFieldMain.appendChild(label);
    modalItemFieldMain.appendChild(input);

    modalItem.prepend(modalItemFieldMain);
    this.form.appendChild(modalItem);
    this.fields.set(name, input);

    input.oninput = () => this.handleInputChange();
  }

  private handleInputChange() {
    const hasInvalid = Array.from(this.fields.values()).some((input) =>
      input.classList.contains("invalid")
    );
    const noChange = Array.from(this.fields.entries()).every(
      ([key, input]) => input.value === this.openValues[key]
    );
    this.okButton.disabled = hasInvalid || noChange;
  }

  private clearFields(): void {
    this.fields.forEach((input) => (input.value = ""));
  }
}

export class FileUploadElement {
  private fileUploadElement: HTMLDivElement;
  private fileUploadButton: HTMLButtonElement;
  private fileInput: HTMLInputElement;
  private fileListContainer: HTMLDivElement;
  private fileList: HTMLUListElement;
  private filesElemets: FileElement[];
  private loadingIndicator: HTMLDivElement;

  private caseId: string | null = null;
  private caseCreationCallback: (caseId: string) => Promise<void>;
  private checkInputCallback: (isBusy: boolean) => void;
  private getDocumentFile: () => Promise<documentFile>;
  private taskCategory: TaskCategory;
  private taskCategoryName: string;

  constructor(
    caseCreationCallback: (caseId: string) => Promise<void>,
    checkInputCallback: (isBusy: boolean) => void,
    getDocumentFile: () => Promise<documentFile>,
    taskCategory: TaskCategory,
    taskCategoryName: string // for custom properties
  ) {
    this.caseCreationCallback = caseCreationCallback;
    this.checkInputCallback = checkInputCallback;
    this.getDocumentFile = getDocumentFile;
    this.taskCategory = taskCategory;
    this.taskCategoryName = taskCategoryName;
    this.filesElemets = [];

    this.fileUploadElement = document.createElement("div");
    this.fileUploadButton = document.createElement("button");
    this.fileListContainer = document.createElement("div");
    this.fileList = document.createElement("ul");

    this.fileUploadElement.classList.add("file-upload-element");
    this.fileUploadButton.classList.add("settings-button-small"); // similar to nav-button
    this.fileList.classList.add("file-list");

    this.fileUploadElement.title = translate("file-upload");
    this.fileUploadButton.innerHTML = '<i class="fa fa-upload"></i>';

    this.fileInput = document.createElement("input");
    this.fileInput.type = "file";
    this.fileInput.multiple = true;
    this.fileInput.accept = ".doc,.docx,.txt,.pdf";
    this.fileInput.style.display = "none"; // hide the input element

    this.loadingIndicator = document.createElement("div");
    this.loadingIndicator.classList.add("loading-indicator-files", "gone");
    this.loadingIndicator.innerHTML = '<i class="fa fa-spinner fa-spin"></i>';

    this.fileListContainer.style.marginLeft = "7px";

    this.fileListContainer.appendChild(this.fileList);
    this.fileListContainer.appendChild(this.loadingIndicator);
    this.fileUploadButton.appendChild(this.fileInput);
    this.fileUploadElement.appendChild(this.fileUploadButton);

    this.fileUploadButton.onclick = () => {
      this.fileInput.click();
    };

    this.fileInput.onchange = async (event: Event) => {
      const input = event.target as HTMLInputElement;
      if (!input.files || input.files.length === 0) return;

      try {
        this.checkInputCallback(true);
        this.loadingIndicator.classList.remove("gone");

        const documentFiles: documentFile[] = [];
        Array.from(input.files).forEach((file) => {
          documentFiles.push({ name: file.name, originFileObj: file });
        });

        if (this.caseId === null) {
          // create new llm case (chat) with files

          // base word document file for some task categories
          if (this.taskCategory === "edit-document") {
            documentFiles.unshift(await this.getDocumentFile());
          } else if (this.taskCategory === "chat-with-document") {
            // menu page
            documentFiles.unshift(await this.getDocumentFile());
          } else if (this.taskCategory === "workflow") {
            documentFiles.unshift(await this.getDocumentFile());
          }
          // this.taskCategory === "chat" -> nothing

          const createResponse = await createCaseWithFiles(
            // selectedLlmModelServerUrl,
            documentFiles
          );

          this.caseId = createResponse.case_id;
          await this.caseCreationCallback(createResponse.case_id);
        } else {
          // llm case already exists, add files to it

          await postDocumentLlmReference(this.caseId, documentFiles);
        }
      } catch (error) {
        console.error("Error uploading files:", error);
        toastMessage(translate("error-file-upload"), "error");
      } finally {
        this.checkInputCallback(false);
        this.fileInput.value = ""; // reset the input
        this.loadingIndicator.classList.add("gone");
      }

      this.renderFileList();
    };

    this.renderFileList();
  }

  public elem(): HTMLDivElement {
    return this.fileUploadElement;
  }

  public getFileListElement(): HTMLDivElement {
    return this.fileListContainer;
  }

  public setCaseId(caseId: string): void {
    this.caseId = caseId;
    this.renderFileList();
  }

  private async renderFileList(): Promise<void> {
    if (this.caseId === null) return;

    try {
      this.checkInputCallback(true);

      let llmReferences = await getCaseLlmReferences(this.caseId);
      this.fileList.innerHTML = "";
      this.filesElemets = [];
      if (llmReferences === null || llmReferences.length === 0) return;

      this.loadingIndicator.classList.remove("gone");

      llmReferences = llmReferences.filter(
        (ref) => !(ref.name.startsWith(documentNamePrefix) || ref.reference_type === "playbook")
      );
      // why should caseId still be null here?
      this.filesElemets = llmReferences.map(
        (ref) =>
          new FileElement(
            this.caseId!,
            ref.name,
            ref.id,
            this.renderFileList.bind(this),
            this.checkInputCallback,
            this.loadingIndicator
          )
      );

      this.filesElemets.forEach((fileElement) => {
        this.fileList.appendChild(fileElement.elem());
      });
    } catch (error) {
      console.error("Error fetching file list:", error);
      toastMessage(translate("error-fetch-case-files"), "error");
    } finally {
      this.checkInputCallback(false);
      this.loadingIndicator.classList.add("gone");
    }
  }
}

export class FileElement {
  private caseId: string;
  private fileName: string;
  private documentId: string;
  private fileElement: HTMLLIElement;
  private removeButton: HTMLButtonElement;
  private renderCallback: () => Promise<void>;
  private checkInputCallback: (isBusy: boolean) => void;
  private loadingIndicator: HTMLDivElement;

  constructor(
    caseId: string,
    fileName: string,
    documentId: string,
    rederCallback: () => Promise<void>,
    checkInputCallback: (isBusy: boolean) => void,
    loadingIndicator: HTMLDivElement
  ) {
    this.renderCallback = rederCallback;
    this.checkInputCallback = checkInputCallback;
    this.loadingIndicator = loadingIndicator;

    this.caseId = caseId;
    this.fileName = fileName;
    this.documentId = documentId;

    this.fileElement = document.createElement("li");
    this.fileElement.style.listStyleType = "none";
    // this.fileElement.textContent = file.name;
    this.fileElement.innerHTML = `<span><i class="fa fa-link"></i>${this.fileName}</span>`;
    this.fileElement.classList.add("file-element");

    this.removeButton = document.createElement("button");
    this.removeButton.innerHTML = '<i class="fa fa-trash"></i>';
    this.removeButton.classList.add("remove-file-button");
    this.removeButton.title = translate("remove-file");

    this.removeButton.onclick = async () => {
      try {
        checkInputCallback(true);
        this.loadingIndicator.classList.remove("gone");

        const deleteResponse = await deleteDocumentLlmReference(this.caseId, this.documentId);
      } catch (error) {
        console.error("Error deleting file:", error);
        toastMessage(translate("error-file-delete"), "error");
      } finally {
        checkInputCallback(false);
        this.loadingIndicator.classList.add("gone");
      }

      this.renderCallback();
    };

    this.fileElement.appendChild(this.removeButton);
  }

  public elem(): HTMLLIElement {
    return this.fileElement;
  }
}
